
















































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import LocationDto from "@/models/Locations/LocationDto";
import UpdateLocationGeneralDetailsRequest from "@/models/Locations/UpdateLocationGeneralDetailsRequest";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import { LocationDetailsModule } from "@/store/modules/locationDetails";
import { AgencySettingsModule } from "@/store/modules/agencySettings";

@Component({
  name: "LocationGeneralDetailsEdit",
})
export default class extends GiganautVueDialog {

public entity = new LocationDto();

  @Watch("dialog")
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(
        JSON.stringify(LocationDetailsModule.currentLocation)
      );
    }
  }

  get loading() {
    return LocationDetailsModule.loadingDialog;
  }

  get rateCards() {
    return LocationDetailsModule.rateCards;
  }

  get locationTypes() {
    return AgencySettingsModule.locationTypes;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateLocationGeneralDetailsRequest();
    request.updatedAt = LocationDetailsModule.currentLocation.updatedAt;
    request.registeredName = this.entity.registeredName;
    request.emailAddress = this.entity.emailAddress;
    request.phoneNumber = this.entity.phoneNumber;
    request.taxNumber = this.entity.taxNumber;
    request.registrationNumber = this.entity.registrationNumber;
    request.rateCardId = this.entity.rateCard.id;
    request.locationTypeId = this.entity.locationType.id;
    await LocationDetailsModule.editLocationGeneralDetails(request);
    this.dialog = false;
  }
}
